import type { ServiceForSelectedServiceType } from '@common/interfaces/processStartWizard';
import { ServiceCode } from '@common/enums';
import { never } from '@common/utils/never';
import type { IServiceDataItem } from './getServiceData';

export function getServiceDataForEpisodePulmonology(
    service: ServiceForSelectedServiceType,
    serviceCode: ServiceCode.TPO | ServiceCode.TPC
): Partial<IServiceDataItem> {
    switch (serviceCode) {
        case ServiceCode.TPO:
            if (service.isServiceProvider) {
                return {
                    costs: 'geen',
                    steps: [
                        'Jij doet het onderzoek zelf en uploadt de spirogram in het Ksyos portaal. De anamnese en medicatielijst kunnen hierbij worden toegevoegd.',
                        'Je kan zelf een pluis/niet pluis beoordeling doen of dit doorsturen naar een zorgverlener binnen de praktijk die dit kan doen',
                    ],
                    subTitle: (
                        <>
                            Voor het <strong>beoordelen van de spirogram</strong>
                        </>
                    ),
                    title: 'Longfunctieonderzoek (zelf uitvoeren)',
                    waitingTime: 'geen',
                };
            } else {
                return {
                    costs: 'geen',
                    steps: [
                        'De assistente of POH vraagt het onderzoek aan via het Ksyos portaal en zet dit door naar de zorgverlener binnen de praktijk',
                        'De zorgverlener voert het onderzoek uit',
                        'Dit kan worden doorgestuurd naar een POH/ huisarts voor een pluis/niet pluis beoordeling',
                    ],
                    subTitle: (
                        <>
                            Voor het <strong>beoordelen van de spirogram</strong>
                        </>
                    ),
                    title: 'Longfunctieonderzoek (aanvragen)',
                    waitingTime: 'geen',
                };
            }

        case ServiceCode.TPC:
            return {
                costs: 'eigen risicovrij, huisarts declareert M&I tarief',
                steps: [
                    ' Stel je vraag aan een Ksyos longarts',
                    'De longarts beoordeelt de vraag digitaal',
                    ' Je ontvangt de uitslag via Edifact (in je HIS)',
                ],
                subTitle: (
                    <>
                        Voor het stellen van <strong>een vraag na het afnemen van een spirogram</strong>
                    </>
                ),
                title: 'Meekijkconsult',
                waitingTime: '48 uur',
            };

        default:
            never(serviceCode);
    }
}
